import { FC, PropsWithChildren, useRef } from 'react';

import { convertCentsToRubles, convertRublesToCents } from 'utils/clickme';

import { NumberInput } from '@hh.ru/magritte-ui';
import { ControlledNumberInputProps } from '@hh.ru/magritte-ui-input/types';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    decimalLengthError: 'formattedNumericInput.error.notNumber',
    notNumberError: 'formattedNumericInput.error.notNumber',
    currency: 'currency.short',
};

const formatPrice = (price: string, decimalMark: string[]): string => {
    const firstChar = price.charAt(0);
    const secondChar = price.charAt(1);
    let formatted = price;

    if (secondChar && firstChar === '0' && !decimalMark.includes(secondChar)) {
        formatted = formatted.slice(1);
    }

    return formatted;
};

export type MoneyInputProps = ControlledNumberInputProps & {
    value: string;
    showPostfix?: boolean;
    dataQa?: string;
};

export const MoneyInput: FC<MoneyInputProps & PropsWithChildren> = ({
    decimalLength = 0,
    onChange,
    value,
    decimalMark = [','],
    dataQa = 'money-input',
    showPostfix = true,
    ...inputProps
}) => {
    const trl = useTrls();
    const inputRef = useRef<HTMLInputElement>(null);

    const onInputChange = (value: string) => {
        const formattedValue = formatPrice(value, decimalMark);
        if (inputRef.current) {
            onChange(convertRublesToCents(formattedValue));
        }
    };

    return (
        <NumberInput
            ref={inputRef}
            decimalLength={decimalLength}
            decimalMark={decimalMark}
            onChange={onInputChange}
            value={convertCentsToRubles(value, decimalLength)}
            allowNegative={false}
            postfix={showPostfix && trl(TrlKeys.currency)}
            data-qa={dataQa}
            {...inputProps}
            prefix={undefined}
        />
    );
};
